import type { Translation } from '../types.ts';
import type en from '../en/portfolio.ts';

export default {
    index: {
        title: 'Portfolio',
        description: "Elke collectie is een groep waartussen bezoekers wisselen. De foto's (en hun volgorde) komen uit de mediamap die je eraan koppelt, dus voeg foto's toe en orden ze onder {media}.",
        mediaLink: 'Media',
        noFolder: '(Geen map)',
        newCollection: 'Nieuwe collectie',
        newCollectionPlaceholder: 'Portretten',
        mediaFolder: 'Mediamap',
        empty: 'Nog geen collecties. Voeg er hierboven een toe en koppel hem aan een mediamap.',
        noFolderHidden: 'Geen map: niet zichtbaar op de site',
        emptyFolderHidden: 'Map is leeg: niet zichtbaar op de site',
        photos: "geen foto's | {n} foto | {n} foto's",
        confirmDelete: "“{name}” verwijderen? De map en de foto's erin blijven ongemoeid.",
    },
} satisfies Translation<typeof en>;
